import z from 'zod';
import { responseBaseSchema } from '../shared.types';

export const idNameSchema = z.object({
    id: z.number().int(),
    name: z.string(),
});

// ---- Bulk Pushdown Filters ----

export const bulkPushdownFiltersRequestSchema = z.object({
    baselineId: z.string(),
});

export const bulkPushdownFiltersResponseSchema = z.object({
    ...responseBaseSchema.shape,
    isProjectsActive: z.boolean(),
    isProjectIdRequiredForLocationTask: z.boolean(),
    projects: z.array(idNameSchema),
});

// ---- Bulk Location Attribute Filters ----

export const bulkLocationAttribFiltersResponseSchema = z.object({
    ...responseBaseSchema.shape,
    areas: z.array(idNameSchema),
    brands: z.array(idNameSchema),
    continents: z.array(idNameSchema),
    countries: z.array(idNameSchema),
    locationTypes: z.array(idNameSchema),
    managementCompanies: z.array(idNameSchema),
    regions: z.array(idNameSchema),
});

// ---- Bulk Location Pushdown Search ----

export const bulkLocationPushdownSearchRequestSchema = z.object({
    baselineId: z.string(),
    projectId: z.string().optional().nullable(),
    // LocationNameForm
    term: z.string().optional(),
    isNameSearch: z.boolean().optional(),
    // LocationAttributesForm
    areaIds: z.array(z.string()).optional(),
    brandIds: z.array(z.string()).optional(),
    continentIds: z.array(z.string()).optional(),
    countryIds: z.array(z.string()).optional(),
    managementCompanyIds: z.array(z.string()).optional(),
    typeIds: z.array(z.string()).optional(),
    regionIds: z.array(z.string()).optional(),
    openingStartDate: z.string().optional(),
    openingEndDate: z.string().optional(),
});

export const bulkLocationPushdownSearchNoProjectRequestSchema = bulkLocationPushdownSearchRequestSchema
    .omit({ projectId: true })
    .extend({
        baselineTaskIdList: z.array(z.number().int()),
    });

export const bulkLocationPushdownSearchResponseSchema = z.object({
    ...responseBaseSchema.shape,
    locations: z.array(idNameSchema),
});

// ---- Bulk Pushdown ----

export const bulkPushdownRequestSchema = z.object({
    baselineTaskIds: z.array(z.number().int()),
    locationIds: z.array(z.number().int()),
    projectId: z.string().optional().nullable(),
});

export const bulkPushdownResponseSchema = responseBaseSchema;

// ---- Type Exports ----

export type IdName = z.infer<typeof idNameSchema>;
export type BulkPushdownFiltersRequest = z.infer<typeof bulkPushdownFiltersRequestSchema>;
export type BulkPushdownFiltersResponse = z.infer<typeof bulkPushdownFiltersResponseSchema>;
export type BulkLocationAttribFiltersResponse = z.infer<typeof bulkLocationAttribFiltersResponseSchema>;
export type BulkLocationPushdownSearchRequest = z.infer<typeof bulkLocationPushdownSearchRequestSchema>;
export type BulkLocationPushdownSearchNoProjectRequest = z.infer<typeof bulkLocationPushdownSearchNoProjectRequestSchema>;
export type BulkLocationPushdownSearchResponse = z.infer<typeof bulkLocationPushdownSearchResponseSchema>;
export type BulkPushdownRequest = z.infer<typeof bulkPushdownRequestSchema>;
export type BulkPushdownResponse = z.infer<typeof bulkPushdownResponseSchema>;
